import React from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  useToast,
  Select,
  VStack,
  FormErrorMessage,
  Text,
  HStack,
} from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useStores } from '../../store/store_context';
import { useState, useEffect } from 'react';
import {
  getPanelById,
  getAllRoles,
  updateUserById,
} from '../../store/api_funcs';
import { useNavigate } from 'react-router';
import { values } from 'mobx';
import UserEditForm from '../user_forms/user_edit_form';

import UserModal from '../user_modal';
import UsersSearch from '../users_autocomplete';

// Валидационная схема для Formik и Yup
const validationSchema = Yup.object().shape({
  theme: Yup.string().required('Обязательное поле'),
  adress: Yup.string().required('Обязательное поле'),
  model_url: Yup.string().required('Обязательное поле'),
  fabric_number: Yup.string().required('Обязательное поле'),
});

const dimensionsOptions = [
  '540:1920',
  '1080:2560',
  '1080:1920',
  '1920:1080',
  '2560:1080',
  '1920:540',
  // добавьте здесь другие разрешения, если нужно
];
// Компонент формы для просмотра и изменения данных пользователя
const PanelEditForm = ({
  panel_id,
  onSubmit,
  updatePanelsTable,
  usernames = '',

  getTableUsers,
  panels,
}) => {
  const { pageStore } = useStores();
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);

  const [initialValues, setInititalValues] = useState();

  const getPanelInfo = async () => {
    setInititalValues(await getPanelById(panel_id, pageStore.token));
  };

  useEffect(() => {
    getPanelInfo();
    getTableRoles();
  }, []);
  const getTableRoles = async () => {
    setRoles(await getAllRoles(pageStore.token));
  };

  const toast = useToast();

  const handleSubmit = async (values, actions) => {
    try {
      await onSubmit(panel_id, values, pageStore.token);
      toast({
        title: 'Данные успешно обновлены.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
      toast({
        title: 'Ошибка',
        description: 'Что-то пошло не так. Пожалуйста, попробуйте снова.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      await updatePanelsTable();
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => (
        <Form>
          <Field name="adress">
            {({ field }) => (
              <FormControl isInvalid={errors.adress && touched.adress}>
                <FormLabel htmlFor="adress">Адрес установки:</FormLabel>
                <Input {...field} id="adress" />
              </FormControl>
            )}
          </Field>
          {pageStore.update_firmware ? (
            <Field name="model_url">
              {({ field }) => (
                <FormControl isInvalid={errors.model_url && touched.model_url}>
                  <FormLabel htmlFor="model_url">модель нейросети:</FormLabel>
                  <Input {...field} id="model_url" />
                </FormControl>
              )}
            </Field>
          ) : null}

          <Field name="fabric_number">
            {({ field }) => (
              <FormControl
                isInvalid={errors.fabric_number && touched.fabric_number}
              >
                <FormLabel htmlFor="fabric_number">
                  Производственный номер:
                </FormLabel>
                <Input {...field} id="fabric_number" />
              </FormControl>
            )}
          </Field>
          <Field name="comment">
            {({ field }) => (
              <FormControl isInvalid={errors.comment && touched.comment}>
                <FormLabel htmlFor="comment">Комментарий:</FormLabel>
                <Input {...field} id="comment" />
              </FormControl>
            )}
          </Field>
          <Field name="dimensions">
            {({ field }) => (
              <FormControl isInvalid={errors.dimensions && touched.dimensions}>
                <FormLabel htmlFor="dimensions">Разрешение:</FormLabel>
                <Select {...field} id="dimensions">
                  {dimensionsOptions.map(option => (
                    <option
                      key={option}
                      style={{ color: 'black' }}
                      value={option}
                    >
                      {option}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage>{errors.dimensions}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
          <VStack paddingTop={5} align={'flex-start'} width={'100%'}>
            {pageStore.edit_themes ? (
              <a
                href={`http://212.41.9.251:5143?panel_id=${panel_id}&fabric_number=${initialValues?.fabric_number}&token=${pageStore.token}`}
                target="_blank"
              >
                <Button
                  color="white"
                  backgroundColor={'#4945FF'}
                  _hover={{ backgroundColor: '#7B79FF' }}
                >
                  Настройка темы
                </Button>
              </a>
            ) : null}
            {pageStore.get_errors ? (
              <Button
                color="white"
                backgroundColor={'#4945FF'}
                _hover={{ backgroundColor: '#7B79FF' }}
              >
                Системный отчет
              </Button>
            ) : null}

            <Button mt={4} colorScheme="blue" type="submit">
              Сохранить
            </Button>
            <VStack width={'100%'}>
              {usernames &&
                usernames.split(',').map(username => {
                  return (
                    <HStack width={'100%'} justify={'space-between'}>
                      <Text>{username}</Text>
                      <UserModal>
                        <UserEditForm
                          user_id={Number(username.split(':')[0])}
                          updateUsersTable={getTableUsers}
                          onSubmit={updateUserById}
                          rolesForUserForm={roles}
                          panels={panels}
                        />
                      </UserModal>
                    </HStack>
                  );
                })}
            </VStack>
          </VStack>
        </Form>
      )}
    </Formik>
  );
};

export default PanelEditForm;
